export default function GarageDoorTypesElPaso() {
  const types = [
    {
      name: 'Sectional Garage Doors',
      description: 'Most popular type with horizontal panels that roll up and overhead, offering excellent insulation and space efficiency.',
      material: 'Steel, Aluminum, Wood',
      bestFor: 'Residential homes, standard garages, energy efficiency',
      image: 'https://public.readdy.ai/ai/img_res/552980fc5216a5142f7dc08234f60aab.jpg'
    },
    {
      name: 'Roll-Up Garage Doors',
      description: 'Commercial-grade doors that roll into a coil above the opening, ideal for businesses and storage facilities.',
      material: 'Steel, Aluminum',
      bestFor: 'Commercial buildings, warehouses, storage units',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20roll-up%20garage%20door%20on%20El%20Paso%20business%2C%20industrial%20steel%20door%20coiling%20overhead%2C%20professional%20commercial%20property%20with%20clean%20exterior%2C%20modern%20business%20facility%20with%20quality%20security%20features%2C%20architectural%20photography&width=600&height=400&seq=garage-door-type-002&orientation=landscape'
    },
    {
      name: 'Carriage House Doors',
      description: 'Traditional swing-out or swing-up design with decorative hardware, adding classic charm and curb appeal.',
      material: 'Wood, Steel with Wood Overlay',
      bestFor: 'Historic homes, luxury properties, custom designs',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20carriage%20house%20garage%20doors%20on%20upscale%20El%20Paso%20home%2C%20traditional%20swing-out%20design%20with%20decorative%20hardware%2C%20beautiful%20wood%20finish%20on%20southwestern%20style%20residence%2C%20luxury%20home%20exterior%20with%20classic%20architectural%20details%2C%20high-end%20residential%20photography&width=600&height=400&seq=garage-door-type-003&orientation=landscape'
    },
    {
      name: 'Side-Hinged Doors',
      description: 'Traditional doors that swing open from the side, perfect for garages used as workshops or frequent pedestrian access.',
      material: 'Wood, Steel, Fiberglass',
      bestFor: 'Workshop garages, frequent access, traditional style',
      image: 'https://readdy.ai/api/search-image?query=Side-hinged%20garage%20doors%20on%20El%20Paso%20home%2C%20traditional%20swing-open%20design%20with%20classic%20hardware%2C%20convenient%20pedestrian%20access%20on%20residential%20property%2C%20clean%20installation%20with%20quality%20materials%2C%20architectural%20detail%20photography&width=600&height=400&seq=garage-door-type-004&orientation=landscape'
    },
    {
      name: 'Insulated Steel Doors',
      description: 'Energy-efficient doors with polyurethane or polystyrene insulation, ideal for El Paso\'s extreme temperatures.',
      material: 'Insulated Steel',
      bestFor: 'Climate control, energy savings, noise reduction',
      image: 'https://readdy.ai/api/search-image?query=Insulated%20steel%20garage%20door%20on%20modern%20El%20Paso%20home%2C%20energy-efficient%20design%20with%20thermal%20protection%2C%20contemporary%20residential%20exterior%20in%20desert%20climate%2C%20quality%20construction%20showing%20insulation%20benefits%2C%20professional%20installation%20photography&width=600&height=400&seq=garage-door-type-005&orientation=landscape'
    },
    {
      name: 'Custom Wood Doors',
      description: 'Handcrafted wooden doors with unique designs, stains, and finishes for distinctive architectural statements.',
      material: 'Cedar, Redwood, Mahogany',
      bestFor: 'Luxury homes, custom architecture, unique designs',
      image: 'https://readdy.ai/api/search-image?query=Custom%20wood%20garage%20doors%20on%20luxury%20El%20Paso%20home%2C%20handcrafted%20design%20with%20beautiful%20natural%20wood%20grain%2C%20high-end%20residential%20property%20with%20southwestern%20elegance%2C%20premium%20quality%20craftsmanship%20and%20unique%20architectural%20details%2C%20luxury%20home%20photography&width=600&height=400&seq=garage-door-type-006&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Garage Door Types for El Paso Homes
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the perfect garage door style for your property. Each type offers unique benefits for different applications and architectural styles.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border-2 border-gray-200 hover:border-teal-500 transition-all">
              <div className="relative h-48 w-full">
                <img 
                  src={type.image} 
                  alt={type.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{type.name}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{type.description}</p>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start gap-2">
                    <i className="ri-stack-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Materials</p>
                      <p className="text-xs text-gray-600">{type.material}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Best For</p>
                      <p className="text-xs text-gray-600">{type.bestFor}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
